import React, { useEffect, useRef } from "react";
import QrFrameWrapper from "../../page/ThirdScreen/qrSettings/framesQr/QrFrameWrapper";
import FrameText from "../../page/ThirdScreen/qrSettings/framesQr/frameText";
import { safariOrIphone } from "../../hooks/helpers";
import { useSelector } from "react-redux";

const QrTemplate = ({
  wrapRef,
  gRef,
  canvasQr = false,
  transparent = false,
  selectedFrame = null,
  template = null,
}) => {
  const { qrFrames, qrText, qrSettings } = useSelector((state) => state);
  const ref = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (canvasQr && safariOrIphone) {
        ref.current.innerHTML = `<img src="${gRef.current?.lastElementChild?.toDataURL()}" class="img-fluid" />`;
      }
    }, 500);
  }, [qrFrames, qrText, qrSettings, selectedFrame, template]);

  const selectedTemplate = template || { qrFrames, qrText, qrSettings };

  return (
    <svg
      ref={wrapRef || null}
      id={canvasQr || selectedFrame ? undefined : "svgQrWrapper"}
      viewBox="0 0 300 300"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={300}
      height={300}
      style={{
        // shapeRendering: "crispEdges",
        width: "100%",
        height: "100%",
        backgroundColor:
          selectedTemplate.qrSettings.patternBackgroundTransparent ||
          transparent
            ? "transparent"
            : selectedTemplate.qrSettings.patternBackground,
      }}
    >
      <QrFrameWrapper
        frame={
          selectedFrame ? selectedFrame.name : selectedTemplate.qrFrames.frame
        }
        frameColor={selectedTemplate.qrFrames.frameColor}
        isTransformFrameWithTextTemplate={
          selectedTemplate.qrFrames.frameTextToggle
        }
      >
        {canvasQr ? (
          <g
            transform={
              selectedFrame
                ? selectedFrame.transformQr
                : selectedTemplate.qrFrames.frameTransform
            }
            fill="none"
          >
            <foreignObject ref={ref} height="300" width="300">
              <div
                ref={gRef}
                style={{ display: safariOrIphone ? "none" : "block" }}
              />
            </foreignObject>
          </g>
        ) : (
          <g
            ref={gRef}
            transform={selectedTemplate.qrFrames.frameTransform}
            fill="none"
          />
        )}
      </QrFrameWrapper>
      {!!selectedTemplate.qrFrames.frameTextToggle && (
        <FrameText
          text={selectedTemplate.qrText.frameText}
          transform={
            selectedFrame
              ? selectedFrame.transformFrameText
              : selectedTemplate.qrFrames.transformFrameText
          }
          textColor={selectedTemplate.qrFrames.frameTextColor}
          textFont={selectedTemplate.qrFrames.frameTextFont}
          textSize={selectedTemplate.qrText.textSize}
        />
      )}
    </svg>
  );
};

export default QrTemplate;
